import React, { FC, useState } from 'react'

import Loading from '../../../Components/loading/Loading'

import loading from '../../../assets/img/loading.gif'

import { useDispatch, useSelector } from 'react-redux'
import { isValidEmail } from '../../../utils/general'
import { MeetingPageField, MeetingPageFieldType } from '../../../types/plann3r'
import DurationField from './fields/DurationField'
import { MeetingPageStore } from '../../../store/meeting-page/types'
import { Plann3rStore } from '../../../store/types'
import { linkUpdateIsVideoCall, linkUpdateMeetingDuration, linkUpdateValue, meetingPageSetMomentPicking } from '../../../store/meeting-page/actions'
import LocationField from './fields/LocationField'
import TextAreaField from './fields/TextAreaField'
import TextField from './fields/TextField'
import { PLANN3R_COLOR } from '../../../constants'

const StartPage: FC = () => {
  const [error, seterror] = useState('')
  const [submitted, setsubmitted] = useState(false)

  const dispatch = useDispatch()

  const {
    isFetching,
    fields,
    colors,
    logo,
    display_name,
    copy,
    locations,
    duration,
  } = useSelector((state: Plann3rStore): MeetingPageStore => state.meetingPage)

  const strings = useSelector((state: Plann3rStore) => state.languages.strings.link.almostdone)

  const submit = () => {
    const email = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.EMAIL
    })[0].value

    const location = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.LOCATION
    })[0].value

    const duration_value = fields.filter((field: MeetingPageField) => {
      return field.type === MeetingPageFieldType.DURATION
    })[0].value

    let allRequiredFilled = true

    for (let i = 0; i < fields.length; i++) {
      if (fields[i].required && fields[i].value === '') {
        allRequiredFilled = false
      }
    }

    if (
      isValidEmail(email + '') &&
      allRequiredFilled &&
      location !== '' &&
      duration_value !== '' &&
      duration !== 0
    ) {
      setsubmitted(true)
      
      dispatch(meetingPageSetMomentPicking(true))
      seterror('')
    } else {
      seterror(strings.please_fill)
    }
  }

  const renderField = (field: MeetingPageField) => {
    switch (field.type) {
      case MeetingPageFieldType.TEXT:
        return (
          <TextAreaField
            key={field.id}
            id={field.id}
            field={field}
            label={field.label}
            type={field.type}
            required={field.required}
            value={field.value}
            onChange={(value: string) => dispatch(linkUpdateValue(field.id, value))}
          />
        )
      case MeetingPageFieldType.NAME:
      case MeetingPageFieldType.EMAIL:
        return (
          <TextField
            key={field.id}
            id={field.id}
            field={field}
            label={field.label}
            type={field.type}
            required={true}
            value={field.value}
            onChange={(value: string) => dispatch(linkUpdateValue(field.id, value))}
          />
        )
      case MeetingPageFieldType.LOCATION:
        return (
          <LocationField
            key={field.id}
            id={field.id}
            field={field}
            label={field.label}
            type={field.type}
            colors={colors}
            required={true}
            value={field.value}
            locations={locations}
            onLocationChange={(value: string, isVideoCall: boolean) => {
              dispatch(linkUpdateValue(field.id, value))
              dispatch(linkUpdateIsVideoCall(isVideoCall))
            }}
          />
        )
      case MeetingPageFieldType.DURATION:
        return (
          <DurationField
            key={field.id}
            id={field.id}
            field={field}
            label={field.label}
            type={field.type}
            required={true}
            value={field.value}
            // eslint-disable-next-line no-console
            onChange={(value) => { console.log(value) }}
            onDurationChange={(value: string, duration: number) => {
              dispatch(linkUpdateValue(field.id, value))
              dispatch(linkUpdateMeetingDuration(duration))
            }}
          />
        )
      default:
        return <div key={field.id} />
    }
  }

  if (isFetching) {
    return (
      <div className="has-text-centered h-full">
        <Loading />
      </div>
    )
  }

  return (
    <div
      className="grey round-corners page pageStart startpage"
      style={{
        color: colors?.primary ?? PLANN3R_COLOR,
        maxWidth: '800px',
        margin: '0 auto',
      }}
    >
      <div className="has-text-centered">
        <img
          src={logo}
          alt={display_name}
          className="logoCompanyPage"
        />
        {copy?.tag_line && (
          <p
            className="font-bolder mb-0"
            style={{
              fontSize: '25px',
              color: colors?.primary ?? PLANN3R_COLOR,
            }}
          >
            {copy?.tag_line}
          </p>
        )}
        {(!copy?.tag_line || copy?.tag_line === '') && (
          <p
            className="font-bolder mb-0"
            style={{
              fontSize: '25px',
              color: colors?.primary ?? PLANN3R_COLOR,
            }}
          >
            {strings.meeting_schedule}
            <b
              className="font-bold"
              style={{
                color: colors?.secondary,
              }}
            >
              {display_name}
            </b>
          </p>
        )}
      </div>
      <div>
        <div>{fields.map(renderField)}</div>

        <div className="has-text-centered">
          {error && <div className="error">{error}</div>}
          {!submitted && (
            <button
              className="button is-primary acceptButton"
              style={{ backgroundColor: colors?.secondary }}
              onClick={submit}
            >
              {copy?.button ?? strings.pick_moment}
            </button>
          )}

          {submitted && (
            <div className="has-text-centered">
              <img style={{ height: '50px' }} src={loading} alt="" />
              <p style={{ maxWidth: '400px', margin: '0 auto' }}>
                {strings.loading_calendars}
              </p>
            </div>
          )}

          {!submitted && <span className="required">{strings.required}</span>}
        </div>
      </div>
    </div>
  )
}

export default StartPage
